export const getActiveTreatment = <
  Treatment extends { active: boolean } | null | undefined,
>(
  treatments?: Treatment[] | null | undefined,
): Treatment | undefined => {
  return treatments?.find((treatment) => treatment?.active);
};
